import { render } from "./SearchArtists.vue?vue&type=template&id=0bf1030a&scoped=true"
import script from "./SearchArtists.vue?vue&type=script&lang=js"
export * from "./SearchArtists.vue?vue&type=script&lang=js"

import "./SearchArtists.vue?vue&type=style&index=0&id=0bf1030a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf1030a"]])

export default __exports__